import React, {useEffect, useRef, useState} from 'react';
import Header from '../../../components/layout/headers/Header'
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation"
import CreateNewPolicyPage from "./create/CreateNewPolicyPage"
import apiClient from "../../../services/api-client";
import {Divider} from 'primereact/divider';
import {Button} from 'primereact/button';
import AppCard from '../../../components/ui/AppCard';
import InfoField from '../../../components/ui/InfoField';
import StatusBadge from '../../../components/ui/StatusBadge';
import localBGImage from "../../../assets/images/patterns/applyPolicy.png"
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logoImg from '../../../assets/images/logo.png';
import {Skeleton} from 'primereact/skeleton';
import Menu from '../../../components/common/Menu';
import {useMountEffect} from 'primereact/hooks';
import {Dialog} from 'primereact/dialog';
import localBGImageBeneficiaries from "../../../assets/images/patterns/beneficiaries-bg.png"
import {Accordion, AccordionTab} from 'primereact/accordion';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import AddBeneficiaryMembers from "./create/components/policyForm/AddBeneficiaryMembers.jsx";
import {ConfirmPopup} from 'primereact/confirmpopup';
import {Toast} from 'primereact/toast';
import StorageHelper from '../../../utils/storage-helper';
import {addBeneficiary, deleteBeneficiary, editBeneficiary} from '../../../services/beneficiary-service';
import BeneficiaryDialog from "../components/BeneficiaryDialog";

const ManagePolicy = () => {

    const toast = useRef(null);
    const [balanceDetails, setBalanceDetails] = useState(null);
    const [policyDisplay, setPolicyDisplay] = useState(null);
    const [selectedPolicy, setSelectedPolicy] = useState(null);

    const [loading, setLoading] = useState(true);

    const [, setPolicyValue] = useState(null);
    const [policyDisplayKey, setPolicyDisplayKey] = useState(1);
    let userProfile = {};
    const [newBenVisible, setNewBenVisible] = useState(false);

    // Beneficiary change-request form state
    const [beneficiaryDialog, setBeneficiaryDialog] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [selectedBen, setSelectedBen] = useState(null);
    const [deleteReason, setDeleteReason] = useState('');

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        idNumber: '',
        passportNumber: '',
        title: 'Mr',
        gender: 'MALE',
        relationship: 'CHILD',
        dateOfBirth: '',
        emailAddress: '',
        phoneNumber: '',
        reason: ''
    });

    const openAddDialog = () => {
        setIsEditMode(false);
        setFormData({
            firstName: '',
            lastName: '',
            idNumber: '',
            passportNumber: '',
            title: 'Mr',
            gender: 'MALE',
            relationship: 'CHILD',
            dateOfBirth: '',
            emailAddress: '',
            phoneNumber: '',
            reason: ''
        });
        setFormErrors({});
        setBeneficiaryDialog(true);
    };

    const openEditDialog = (ben, relationshipType) => {
        setIsEditMode(true);
        setSelectedBen({...ben, relationshipType});

        let dobStr = ben.Date_of_Birth || ben.Date_of_birth || ben.BenDOB || '';
        if (dobStr && dobStr.includes('T')) {
            dobStr = dobStr.split('T')[0];
        }

        setFormData({
            firstName: ben.Name || ben.FirstName || ben.BenName || '',
            lastName: ben.Surname || ben.LastName || ben.BenSurname || '',
            idNumber: ben.ID_num || ben.ID_Num || ben.IdNumber || ben.BenID || '',
            passportNumber: ben.PassportNumber || ben.Passport_num || '',
            title: ben.Title || ben.BenTitle || 'Mr',
            gender: ben.Gender || ben.BenGender || 'MALE',
            relationship: relationshipType,
            dateOfBirth: dobStr,
            emailAddress: ben.EmailAddress || ben.emailAddress || '',
            phoneNumber: ben.Telephone || ben.phoneNumber || ben.BenTelephone || '',
            reason: ''
        });
        setFormErrors({});
        setBeneficiaryDialog(true);
    };

    const openDeleteDialog = (ben, relationshipType) => {
        setSelectedBen({...ben, relationshipType});
        setDeleteReason('');
        setDeleteDialog(true);
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.firstName.trim()) errors.firstName = 'First name is required';
        if (!formData.lastName.trim()) errors.lastName = 'Last name is required';
        if (!formData.idNumber.trim()) errors.idNumber = 'ID number is required';
        if (!formData.title.trim()) errors.title = 'Title is required';
        if (!formData.gender.trim()) errors.gender = 'Gender is required';
        if (!formData.relationship.trim()) errors.relationship = 'Relationship is required';
        if (!formData.dateOfBirth) errors.dateOfBirth = 'Date of birth is required';
        if (!formData.reason.trim()) errors.reason = 'Reason is required';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFormSubmit = async () => {
        if (!validateForm()) return;
        setSubmitting(true);
        try {
            const activePolicy = selectedPolicy || (balanceDetails && balanceDetails[policyDisplayKey]);
            const policyNumber = activePolicy ? activePolicy.MainMember.Policy_Number : '';
            if (!policyNumber) {
                toast.current.show({severity: 'error', summary: 'Error', detail: 'No active policy selected'});
                setSubmitting(false);
                return;
            }

            const payload = {
                operation: isEditMode ? 'UPDATE' : 'ADD',
                details: {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    idNumber: formData.idNumber,
                    passportNumber: formData.passportNumber,
                    title: formData.title,
                    gender: formData.gender,
                    relationship: formData.relationship,
                    dateOfBirth: formData.dateOfBirth,
                    emailAddress: formData.emailAddress,
                    phoneNumber: formData.phoneNumber
                },
                reason: formData.reason
            };

            if (isEditMode) {
                const benId = selectedBen.SpouseID || selectedBen.Child_ID || selectedBen.ExtendedFam_ID || selectedBen.BeneficiaryID;
                const memberId = selectedBen.Member_ID || activePolicy.MainMember.Member_ID;
                const editPayload = {
                    memberId: Number(memberId),
                    beneficiaryId: Number(benId),
                    operation: 'UPDATE',
                    details: payload.details,
                    reason: formData.reason
                };
                const res = await editBeneficiary(policyNumber, editPayload);
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: res.data.message || 'Beneficiary change requested successfully'
                });
            } else {
                const res = await addBeneficiary(policyNumber, payload);
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: res.data.message || 'Beneficiary change requested successfully'
                });
            }
            setBeneficiaryDialog(false);
            getPolicyDetails();
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.message || 'An error occurred';
            toast.current.show({severity: 'error', summary: 'Failed', detail: errMsg});
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteSubmit = async () => {
        if (!deleteReason.trim()) {
            toast.current.show({severity: 'warn', summary: 'Required', detail: 'Please provide a reason for deletion'});
            return;
        }
        setSubmitting(true);
        try {
            const activePolicy = selectedPolicy || (balanceDetails && balanceDetails[policyDisplayKey]);
            const policyNumber = activePolicy ? activePolicy.MainMember.Policy_Number : '';
            const benId = selectedBen.SpouseID || selectedBen.Child_ID || selectedBen.ExtendedFam_ID || selectedBen.BeneficiaryID;
            const memberId = selectedBen.Member_ID || activePolicy.MainMember.Member_ID;

            const payload = {
                memberId: Number(memberId),
                beneficiaryId: Number(benId),
                reason: deleteReason
            };

            const res = await deleteBeneficiary(policyNumber, payload);
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: res.data.message || 'Delete request submitted successfully'
            });
            setDeleteDialog(false);
            getPolicyDetails();
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.message || 'An error occurred';
            toast.current.show({severity: 'error', summary: 'Failed', detail: errMsg});
        } finally {
            setSubmitting(false);
        }
    };

    const actionBodyTemplate = (rowData, relationshipType) => {
        return (
            <div className="flex gap-2">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-warning p-button-sm mr-2"
                    onClick={() => openEditDialog(rowData, relationshipType)}
                    tooltip="Edit"
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-button-sm"
                    onClick={() => openDeleteDialog(rowData, relationshipType)}
                    tooltip="Delete"
                />
            </div>
        );
    };

    function parseTrackApplicationResponse(apiResponse, policyDisplayKey) {
        setLoading(false)
        // //console.log(apiResponse);
        if (apiResponse && apiResponse.responseBody && !(Array.isArray(apiResponse.responseBody)) && apiResponse.responseBody.policyApplicationRequestId) {
            //console.log("---- Yes");
            return <NewApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>;

        } else if (apiResponse && apiResponse.responseBody && (Array.isArray(apiResponse.responseBody)) && apiResponse.responseBody.length > 0) {
            //console.log("---- NO");
            return <EasipolPolicyDisplay key={policyDisplayKey} policyList={apiResponse.responseBody}
                                         policyDisplayKey={policyDisplayKey} apiResponse={apiResponse}/>;

        } else {
            //console.log("---- MAYbe");

            return <NewApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>;
        }
    }


    useEffect(() => {
        // fetchActiveProducts()
        //console.log("policyDisplayKey updated:", policyDisplayKey);
    }, [policyDisplayKey]);

    function updateSelectedPolicy(policyValue, policyList, apiResponse) {
        let policyDisplayKey = policyList.findIndex(item => item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number);
        setPolicyDisplayKey(policyList.findIndex(item => item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number));
        setPolicyDisplay(parseTrackApplicationResponse(apiResponse, policyDisplayKey));

        setPolicyValue(policyList[policyDisplayKey])
        setSelectedPolicy(policyList[policyDisplayKey])
    }

    const generateCertificate = async (policy) => {
        const targetPolicy = policy || selectedPolicy || (balanceDetails && balanceDetails[policyDisplayKey]);
        if (!targetPolicy || !targetPolicy.MainMember) return;
        let activePolicy = targetPolicy;
        const policyNumber = targetPolicy.MainMember.Policy_Number;

        if (toast && toast.current) {
            toast.current.show({
                severity: 'info',
                summary: 'Please wait',
                detail: 'Generating your certificate...',
                life: 2000
            });
        }

        if (policyNumber && !policyNumber.includes('/') && activePolicy.ExtendedFamiy === undefined && activePolicy.Spouse === undefined) {
            try {
                const response = await apiClient.get('policy/full/' + encodeURIComponent(policyNumber), {
                    headers: {Authorization: 'Bearer ' + StorageHelper.get('token')}
                });
                if (response.data.status === "SUCCESS" && response.data.responseBody) {
                    const fetchedData = response.data.responseBody;
                    if (Array.isArray(fetchedData)) {
                        const matched = fetchedData.find(p => p.MainMember?.Policy_Number === policyNumber);
                        if (matched) activePolicy = matched;
                    } else if (fetchedData.MainMember) {
                        activePolicy = fetchedData;
                    }
                }
            } catch (error) {
                console.error("Failed to fetch full policy details:", error);
            }
        }

        const m = activePolicy.MainMember || activePolicy;
        const doc = new jsPDF();

        const drawPDF = (logo) => {
            doc.setFillColor(21, 57, 105);
            doc.rect(0, 0, 210, 35, 'F');
            doc.setFillColor(232, 169, 47);
            doc.rect(0, 35, 210, 5, 'F');

            if (logo) {
                // Approximate size based on design (adjust if it looks squished)
                doc.addImage(logo, 'PNG', 14, 5, 25, 25);
                doc.setTextColor(255, 255, 255);
                doc.setFontSize(20);
                doc.setFont('helvetica', 'bold');
                doc.text('DOVES', 45, 18);
                doc.setFontSize(10);
                doc.setFont('helvetica', 'normal');
                doc.text('LIFE ASSURANCE', 45, 25);
            } else {
                doc.setTextColor(255, 255, 255);
                doc.setFontSize(20);
                doc.setFont('helvetica', 'bold');
                doc.text('DOVES', 14, 18);
                doc.setFontSize(10);
                doc.setFont('helvetica', 'normal');
                doc.text('LIFE ASSURANCE', 14, 25);
            }

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(9);
            doc.text('A dignified send-off, thoughtfully planned', 196, 20, {align: 'right'});

            const statusLabel = m.Status === 0 ? "INACTIVE" :
                m.Status === 1 ? "ACTIVE" :
                    m.Status === 2 ? "LAPSED" : "ARCHIVED";

            doc.setTextColor(21, 57, 105);
            doc.setFontSize(22);
            doc.setFont('helvetica', 'bold');
            doc.text('POLICY CERTIFICATE', 14, 55);

            // Draw status badge
            doc.setFontSize(10);
            const statusWidth = doc.getTextWidth(statusLabel) + 12;

            let badgeBg, badgeBorder, badgeText;
            if (statusLabel === "ACTIVE") {
                badgeBg = [235, 247, 238];
                badgeBorder = [40, 167, 69];
                badgeText = [40, 167, 69];
            } else if (statusLabel === "INACTIVE") {
                badgeBg = [253, 237, 237];
                badgeBorder = [220, 53, 69];
                badgeText = [220, 53, 69];
            } else if (statusLabel === "LAPSED") {
                badgeBg = [255, 243, 205];
                badgeBorder = [255, 152, 0];
                badgeText = [255, 152, 0];
            } else {
                badgeBg = [240, 240, 240];
                badgeBorder = [108, 117, 125];
                badgeText = [108, 117, 125];
            }

            doc.setFillColor(...badgeBg);
            doc.setDrawColor(...badgeBorder);
            doc.roundedRect(196 - statusWidth, 48, statusWidth, 8, 2, 2, 'FD');
            doc.setTextColor(...badgeText);
            doc.text(statusLabel, 196 - (statusWidth / 2), 53.5, {align: 'center'});

            doc.setTextColor(100, 100, 100);
            doc.setFontSize(11);
            doc.setFont('helvetica', 'normal');
            doc.text(`${m.Product_Name || 'Doves Cash Plan Adult'} - customer policy summary`, 14, 62);

            let currentY = 70;

            doc.autoTable({
                startY: currentY,
                theme: 'grid',
                headStyles: {fillColor: [245, 247, 250], textColor: [100, 100, 100], fontSize: 8, fontStyle: 'bold'},
                bodyStyles: {textColor: [0, 0, 0], fontSize: 11, fontStyle: 'bold'},
                head: [['POLICY NUMBER', 'POLICYHOLDER', 'INCEPTION DATE']],
                body: [[
                    m.Policy_Number || '-',
                    `${m.Title || ''} ${m.First_Name || ''} ${m.Surname || ''}`.trim(),
                    m.Inception_Date || m.Date_Joined || '-'
                ]],
                margin: {left: 14, right: 14}
            });
            currentY = doc.lastAutoTable.finalY + 15;

            doc.setTextColor(21, 57, 105);
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Policy details', 14, currentY);
            currentY += 4;

            const policyDetailsBody = [
                [{
                    content: 'PLAN',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'PAYMENT METHOD',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{content: m.Product_Name || '-', styles: {fontStyle: 'bold', fontSize: 10}},
                    {content: m.Payment_Method || 'Cash', styles: {fontSize: 10}}],
                [{
                    content: 'MAIN PLAN PREMIUM',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'EXTENDED-FAMILY PREMIUM',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{content: `US$${m.UsualPremium || '0.00'}`, styles: {fontSize: 10}},
                    {content: `US$0.00`, styles: {fontSize: 10}}],
                [{
                    content: 'TOTAL USUAL PREMIUM',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'MAIN-MEMBER WAITING PERIOD',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{content: `US$${m.UsualPremium || '0.00'}`, styles: {fontStyle: 'bold', fontSize: 10}},
                    {content: `0 months recorded`, styles: {fontSize: 10}}]
            ];

            doc.autoTable({
                startY: currentY,
                theme: 'grid',
                body: policyDetailsBody,
                margin: {left: 14, right: 14}
            });
            currentY = doc.lastAutoTable.finalY + 15;

            doc.setTextColor(21, 57, 105);
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Policyholder details', 14, currentY);
            currentY += 4;

            const phDetailsBody = [
                [{
                    content: 'FULL NAME',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'NATIONAL ID',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{
                    content: `${m.Title || ''} ${m.First_Name || ''} ${m.Surname || ''}`.trim(),
                    styles: {fontStyle: 'bold', fontSize: 10}
                },
                    {content: m.ID_Number || '-', styles: {fontSize: 10}}],
                [{
                    content: 'DATE OF BIRTH',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'GENDER',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{content: m.Date_Of_Birth || '-', styles: {fontSize: 10}},
                    {content: m.Gender || '-', styles: {fontSize: 10}}],
                [{
                    content: 'RESIDENTIAL ADDRESS',
                    styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                },
                    {
                        content: 'MOBILE NUMBER',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    }],
                [{content: m.Address || '-', styles: {fontSize: 10}},
                    {content: m.Cell_Number || '-', styles: {fontSize: 10}}]
            ];

            doc.autoTable({
                startY: currentY,
                theme: 'grid',
                body: phDetailsBody,
                margin: {left: 14, right: 14}
            });
            currentY = doc.lastAutoTable.finalY + 15;

            if (activePolicy.ExtendedFamiy && activePolicy.ExtendedFamiy.length > 0) {
                const ext = activePolicy.ExtendedFamiy[0];
                doc.setTextColor(21, 57, 105);
                doc.setFontSize(14);
                doc.setFont('helvetica', 'bold');
                doc.text('Extended-family member', 14, currentY);
                currentY += 4;

                const extBody = [
                    [{
                        content: 'FULL NAME',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    },
                        {
                            content: 'RELATIONSHIP',
                            styles: {
                                fontStyle: 'bold',
                                textColor: [120, 120, 120],
                                fontSize: 8,
                                fillColor: [250, 250, 250]
                            }
                        }],
                    [{
                        content: `${ext.Name || ''} ${ext.Surname || ''}`.trim(),
                        styles: {fontStyle: 'bold', fontSize: 10}
                    },
                        {content: ext.Relation || 'Relative', styles: {fontSize: 10}}],
                    [{
                        content: 'DATE OF BIRTH',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    },
                        {
                            content: 'GENDER',
                            styles: {
                                fontStyle: 'bold',
                                textColor: [120, 120, 120],
                                fontSize: 8,
                                fillColor: [250, 250, 250]
                            }
                        }],
                    [{content: ext.Date_of_birth || '-', styles: {fontSize: 10}},
                        {content: ext.Gender || '-', styles: {fontSize: 10}}],
                    [{
                        content: 'PREMIUM',
                        styles: {fontStyle: 'bold', textColor: [120, 120, 120], fontSize: 8, fillColor: [250, 250, 250]}
                    },
                        {
                            content: 'WAITING PERIOD',
                            styles: {
                                fontStyle: 'bold',
                                textColor: [120, 120, 120],
                                fontSize: 8,
                                fillColor: [250, 250, 250]
                            }
                        }],
                    [{content: `US$0.00`, styles: {fontSize: 10}},
                        {content: `6 months`, styles: {fontSize: 10}}]
                ];
                doc.autoTable({
                    startY: currentY,
                    theme: 'grid',
                    body: extBody,
                    margin: {left: 14, right: 14}
                });
                currentY = doc.lastAutoTable.finalY + 15;
            }

            const pageHeight = doc.internal.pageSize.height;
            doc.setFillColor(21, 57, 105);
            doc.rect(0, pageHeight - 15, 210, 15, 'F');
            doc.setFillColor(232, 169, 47);
            doc.rect(0, pageHeight - 16, 210, 1, 'F');

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(8);
            doc.text('157 & 159 Harare St, Harare  |  +263 242 774013/6  |  enquiries@doves.co.zw  |  doves.co.zw', 105, pageHeight - 7, {align: 'center'});

            const safePolicyNumber = String(m.Policy_Number || '').replace(/\//g, '-');
            doc.save(`Policy Certificate ${safePolicyNumber}.pdf`.trim());
        };

        const img = new Image();
        img.onload = () => drawPDF(img);
        img.onerror = () => drawPDF(null);
        img.src = logoImg;
    };

    function EasipolPolicyDisplay({policyList, policyDisplayKey, apiResponse}) {
        const currentPolicy = policyList && policyList[policyDisplayKey];
        const currentMember = currentPolicy && currentPolicy.MainMember;
        const statusLabel =
            currentMember && currentMember.Status === 0 ? "INACTIVE" :
                currentMember && currentMember.Status === 1 ? "ACTIVE" :
                    currentMember && currentMember.Status === 2 ? "LAPSED" : "ARCHIVED";
        const statusTone =
            currentMember && currentMember.Status === 1 ? "success" :
                statusLabel === "ARCHIVED" ? "danger" : "warning";
        const statusMessage =
            currentMember && (currentMember.Status === 0 || currentMember.Status === 2)
                ? "Make a subscription to enable it"
                : currentMember && statusLabel === "ARCHIVED"
                    ? "Please call our customer service for guidance"
                    : null;


        return (<>
            {policyList ?
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">
                    <div className="lg:col-span-5 flex flex-col h-full">
                        <AppCard headerImg={localBGImage}>
                            <div className="mb-4">
                                <span
                                    className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Policy Summary</span>
                                <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your
                                    Policy Details</h2>
                                <p className="text-sm text-base-content/70">Review the selected policy and member
                                    information.</p>
                            </div>
                            <Divider type="solid" className="opacity-30 my-4"/>

                            <div className="mb-6">
                                <Menu
                                    className="border border-base-300 rounded-xl px-4 py-3 w-full bg-base-100 flex justify-between items-center cursor-pointer shadow-sm"
                                    trigger={({open, toggle}) => (
                                        <button
                                            type="button"
                                            className={`w-full text-left flex justify-between items-center font-bold text-base-content ${open ? " dl-select-trigger--open" : ""}`}
                                            onClick={toggle}
                                        >
                                            <span>{currentMember.Policy_Number}</span>
                                            <i className="icofont-simple-down"></i>
                                        </button>
                                    )}
                                    items={policyList}
                                    getKey={(p) => p.MainMember.Policy_Number}
                                    searchable={policyList.length > 5}
                                    searchPlaceholder="Search policy number"
                                    filterItem={(p, q) =>
                                        p.MainMember.Policy_Number.toLowerCase().includes(q.toLowerCase())
                                    }
                                    renderItem={(p) => (
                                        <span
                                            className="flex justify-between items-center w-full py-2 border-b border-base-200 last:border-0">
                                            <span className="font-semibold text-base-content">
                                                {p.MainMember.Policy_Number}
                                            </span>
                                        </span>
                                    )}
                                    onSelect={(p) => updateSelectedPolicy(p, policyList, apiResponse)}
                                />
                            </div>

                            <div className="mb-6 bg-base-200 rounded-xl p-4">
                                <span className="text-xs uppercase font-bold text-base-content/60 block mb-1">Principal Member</span>
                                <strong
                                    className="text-lg">{currentMember.Title} {currentMember.First_Name} {currentMember.Surname}</strong>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                <InfoField label="Monthly Premium" value={`$ ${currentMember.UsualPremium}`}/>
                                <InfoField
                                    label="Policy Status"
                                    value={<StatusBadge tone={statusTone} label={statusLabel} message={statusMessage}/>}
                                />
                                <InfoField label="Policy Number" value={currentMember.Policy_Number}/>
                                <InfoField label="Policy Product" value={currentMember.Product_Name}/>
                            </div>

                            <div className="mb-6 bg-base-200 rounded-xl p-4">
                                <span
                                    className="text-xs uppercase font-bold text-base-content/60 block mb-1">Address</span>
                                <strong className="block">{currentMember.Address}</strong>
                                <small className="text-base-content/70">{currentMember.Region}</small>
                            </div>

                            <Button
                                label="Download Certificate"
                                icon="pi pi-download"
                                className="p-button-outlined p-button-info w-full mt-2 font-bold"
                                onClick={() => generateCertificate(currentPolicy)}
                            />
                        </AppCard>
                    </div>

                    <div className="lg:col-span-7 flex flex-col h-full">
                        <AppCard headerImg={localBGImageBeneficiaries}>
                            <div className="mb-4">
                                <span
                                    className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Beneficiaries</span>
                                <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your
                                    Beneficiaries</h2>
                                <p className="text-sm text-base-content/70">Manage who is covered under this policy.</p>
                            </div>
                            <Divider type="solid" className="opacity-30 my-4"/>
                            <Accordion activeIndex={0}>
                                <AccordionTab header="Principal Member Details">
                                    <DataTable value={[policyList[policyDisplayKey].MainMember]}
                                               tableStyle={{minWidth: '50rem'}}>
                                        <Column field='ID_Number' header="ID Number"></Column>
                                        <Column field='Title' header="Title"></Column>
                                        <Column field='First_Name' header="First Name"></Column>
                                        <Column field='Surname' header="Last Name"></Column>
                                        <Column field='Date_Of_Birth' header="Date Of Birth"></Column>
                                        <Column field='Gender' header="Gender"></Column>
                                        <Column field='Marital_Status' header="Marital Status"></Column>
                                        {/* <Column field='Address' header="Gender"></Column> */}
                                        <Column field='Cell_Number' header="Cell Number"></Column>
                                    </DataTable>
                                </AccordionTab>
                                <Divider type="dotted"/>
                                <AccordionTab header="Beneficiary Details">
                                    {policyList[policyDisplayKey].Spouse && policyList[policyDisplayKey].Spouse.length !== 0 ? (<>
                                            <h4 className='dl-beneficiary-subheading'>Spouse Beneficiary Details</h4>
                                            <Divider type="dotted"/>
                                            <DataTable value={[policyList[policyDisplayKey].Spouse]}
                                                       tableStyle={{minWidth: '50rem'}}>
                                                <Column field='Member_ID' header="Member_ID"></Column>
                                                <Column field='ID_Num' header="ID Number"></Column>
                                                <Column field='Name' header="First Name"></Column>
                                                <Column field='Surname' header="Last Name"></Column>
                                                <Column field='Date_of_Birth' header="Date Of Birth"></Column>
                                                <Column field='Gender' header="Gender"></Column>
                                                <Column field='Telephone' header="Phone Number"></Column>
                                                <Column header="Actions"
                                                        body={(rowData) => actionBodyTemplate(rowData, 'SPOUSE')}/>
                                            </DataTable></>) :
                                        <><small className="dl-empty-hint">No Spouse Beneficiary Details</small><Divider
                                            type="dotted"/>
                                        </>}

                                    {policyList[policyDisplayKey].Children && policyList[policyDisplayKey].Children.length !== 0 ?
                                        <><h4 className='dl-beneficiary-subheading'>Children Beneficiary Details</h4>
                                            {policyList[policyDisplayKey].Children.map((beneficiary, index) => (
                                                <React.Fragment key={index}><Divider type="dotted"/>
                                                    <DataTable value={[beneficiary]} tableStyle={{minWidth: '50rem'}}>
                                                        <Column field='ID_num' header="ID Number"></Column>
                                                        <Column field='Name' header="First Name"></Column>
                                                        <Column field='Surname' header="Last Name"></Column>
                                                        <Column field='Date_of_birth' header="Date Of Birth"></Column>
                                                        <Column field='Gender' header="Gender"></Column>
                                                        <Column field='AtVarsity' header="Is Tertiary Student"></Column>
                                                        <Column header="Actions"
                                                                body={(rowData) => actionBodyTemplate(rowData, 'CHILD')}/>
                                                    </DataTable></React.Fragment>

                                            ))}
                                        </>
                                        : <><small className="dl-empty-hint">No Child Beneficiary
                                            Details</small><Divider type="dotted"/></>}

                                    {policyList[policyDisplayKey].ExtendedFamiy && policyList[policyDisplayKey].ExtendedFamiy.length !== 0 ?
                                        <> <h4 className='dl-beneficiary-subheading'>Extended Family Beneficiary
                                            Details</h4>
                                            {policyList[policyDisplayKey].ExtendedFamiy.map((beneficiary, index) => (
                                                <React.Fragment key={index}>
                                                    <Divider type="dotted"/>
                                                    <DataTable value={[beneficiary]} tableStyle={{minWidth: '50rem'}}>
                                                        <Column field='ID_num' header="ID Number"></Column>
                                                        <Column field='Name' header="First Name"></Column>
                                                        <Column field='Surname' header="Last Name"></Column>
                                                        <Column field='Date_of_birth' header="Date Of Birth"></Column>
                                                        <Column field='Gender' header="Gender"></Column>
                                                        <Column field='Relation' header="Relationship"></Column>
                                                        <Column header="Actions"
                                                                body={(rowData) => actionBodyTemplate(rowData, 'FAMILY_MEMBER')}/>
                                                    </DataTable>
                                                </React.Fragment>
                                            ))}

                                        </>
                                        : <><small className="dl-empty-hint">No Extended Family Beneficiary
                                            Details</small><Divider type="dotted"/></>}

                                    {policyList[policyDisplayKey].memberBeneficiary && policyList[policyDisplayKey].memberBeneficiary.length !== 0 ?
                                        <> <h4 className='dl-beneficiary-subheading'>Other Beneficiary Details</h4>
                                            {policyList[policyDisplayKey].memberBeneficiary.map((beneficiary, index) => (
                                                <React.Fragment key={index}>
                                                    <Divider type="dotted"/>
                                                    <DataTable value={[policyList[policyDisplayKey].memberBeneficiary]}
                                                               tableStyle={{minWidth: '50rem'}}>
                                                        <Column field='IdNumber' header="ID Number"></Column>
                                                        <Column field='Title' header="Title"></Column>
                                                        <Column field='FirstName' header="First Name"></Column>
                                                        <Column field='Surname' header="Last Name"></Column>
                                                        <Column field='DateOfBirth' header="Date Of Birth"></Column>
                                                        <Column field='Gender' header="Gender"></Column>
                                                        <Column field='Relationship'
                                                                header="Relationship to Principal"></Column>
                                                        <Column field='Telephone' header="Telephone"></Column>
                                                        <Column header="Actions"
                                                                body={(rowData) => actionBodyTemplate(rowData, 'BENEFICIARY')}/>
                                                    </DataTable>
                                                </React.Fragment>
                                            ))}

                                        </>
                                        : <><small className="dl-empty-hint">No Other Beneficiary
                                            Details</small><Divider type="dotted"/></>}

                                    <ConfirmPopup/>
                                    <div className="dl-add-beneficiary">
                                        <p>Add your spouse, children and relative beneficiaries to your existing
                                            policy.</p>
                                        <button
                                            type="button"
                                            className="btn bg-[#135A9C] hover:bg-[#0e4475] text-white border-none rounded-xl"
                                            onClick={openAddDialog}
                                        >
                                            Add New Beneficiary
                                        </button>
                                    </div>
                                </AccordionTab>
                                <AccordionTab header="Banking Details">
                                    {policyList[policyDisplayKey].BankDetail && policyList[policyDisplayKey].BankDetail.length !== 0 ? (
                                        <>
                                            {policyList[policyDisplayKey].BankDetail.map((bankDetail, index) => (
                                                <DataTable key={index} value={[bankDetail]}
                                                           tableStyle={{minWidth: '50rem'}}>
                                                    {/* <Column field='BankName' header="Bank Name"></Column>
                                                            <Column field='BranchName' header="Branch Name"></Column> */}
                                                    <Column field='Account_Name' header="Account Name"></Column>
                                                    <Column field='Account_Number' header="Account Number"></Column>
                                                    <Column field='Type_of_Account' header="Type of Account"></Column>
                                                </DataTable>
                                            ))}
                                        </>) : <></>}

                                </AccordionTab>
                            </Accordion>
                            <Divider type='dotted'/>


                        </AppCard>
                    </div>
                </div> : <h5>Select policy to display</h5>}
        </>);
    }

    function NewApplicationPolicyDisplay(existingApplicationProgress) {
        //console.log("UPDATE  APPLICATION ");
        //console.log(existingApplicationProgress);
        return (
            <>
                <CreateNewPolicyPage className="mt-2" existingApplicationProgress={existingApplicationProgress}/></>
        );
    }

    const getPolicyDetails = async () => {
        setLoading(true)
        try {
            userProfile = (StorageHelper.get('userProfile'));

            await apiClient.get('policy/track/' + userProfile.idnumber, {
                headers: {
                    Authorization: 'Bearer ' + (StorageHelper.get('token'))
                }
            }).then((response) => {

                if (response.data.status === "SUCCESS") {
                    // //console.log(response);

                    if (response.data.responseBody === null) {
                    } else {
                        setBalanceDetails(response.data.responseBody);
                        if (Array.isArray(response.data.responseBody) && response.data.responseBody.length > 0) {
                            setSelectedPolicy(response.data.responseBody[0]);
                        }
                    }

                } else {
                    // //console.log(response.data.status)
                }
                // //console.log(userProfile.idnumber);
                // //console.log(response.data);
                setLoading(false)
                setPolicyDisplay(parseTrackApplicationResponse(response.data, 0))
            });

        } catch (error) {
            setLoading(false)
            console.error('Error fetching balance details:', error);
        }
    };

    useMountEffect(() => {
        getPolicyDetails();
    }, []);

    return (
        <>
            <Toast ref={toast}/>
            <Header/>
            <DynamicNavigation/>
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="w-full">
                        {loading ? (
                                <div className="border-round border-1 surface-border p-4 surface-card">
                                    <div className="flex mb-3">
                                        <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                                        <div>
                                            <Skeleton width="10rem" className="mb-2"></Skeleton>
                                            <Skeleton width="5rem" className="mb-2"></Skeleton>
                                            <Skeleton height=".5rem"></Skeleton>
                                        </div>
                                    </div>
                                    <Skeleton width="100%" height="150px"></Skeleton>
                                    <div className="flex justify-content-between mt-3">
                                        <Skeleton width="4rem" height="2rem"></Skeleton>
                                        <Skeleton width="4rem" height="2rem"></Skeleton>
                                    </div>
                                </div>) :
                            <div className="col-xxl-12 col-xl-12 col-lg-12">
                                {policyDisplay && policyDisplayKey ? policyDisplay : <>{policyDisplay}</>}
                            </div>}
                    </div>
                </div>
            </div>

            {/* Add/Edit Beneficiary Dialog */}
            <BeneficiaryDialog
                visible={beneficiaryDialog}
                onClose={() => setBeneficiaryDialog(false)}
                isEditMode={isEditMode}
                formData={formData}
                setFormData={setFormData}
                formErrors={formErrors}
                submitting={submitting}
                onSubmit={handleFormSubmit}
            />


                {/* Delete Beneficiary Dialog */}
                <Dialog
                    className="dl-dialog"
                    header="Confirm Delete Beneficiary"
                    visible={deleteDialog}
                    style={{width: '400px'}}
                    modal
                    onHide={() => setDeleteDialog(false)}
                >
                    <div className="p-fluid">
                        <p>Are you sure you want to request deletion of this beneficiary?</p>
                        {selectedBen && (
                            <div className="card p-3 mb-3 bg-light">
                                <strong>Name:</strong> {selectedBen.Name || selectedBen.FirstName || selectedBen.BenName} {selectedBen.Surname || selectedBen.LastName || selectedBen.BenSurname}<br/>
                                <strong>Relationship:</strong> {selectedBen.relationshipType}
                            </div>
                        )}
                        <div className="field mb-3">
                            <label htmlFor="deleteReason" className="form-label">Reason for Deletion *</label>
                            <textarea
                                id="deleteReason"
                                rows={3}
                                className="form-control"
                                placeholder="Please provide a reason for deleting this beneficiary"
                                value={deleteReason}
                                onChange={(e) => setDeleteReason(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="flex justify-content-end gap-2 mt-4 text-right">
                        <Button label="Cancel" className="p-button-text p-button-secondary mr-2"
                                onClick={() => setDeleteDialog(false)}/>
                        <Button label={submitting ? "Deleting..." : "Confirm Delete"} severity="danger"
                                icon="pi pi-trash"
                                onClick={handleDeleteSubmit} disabled={submitting}/>
                    </div>
                </Dialog>

                <Dialog className="dl-dialog" header="Add New Beneficiary" visible={newBenVisible}
                        style={{width: '20vw'}}
                        onHide={() => {
                            setNewBenVisible(false)
                        }}>
                    <AddBeneficiaryMembers policyDisplay={policyDisplay}/>
                </Dialog>
        </>
    );
}

export default ManagePolicy;
